import { AddressDetailsQuery, AddressDetailsQueryVariables, UseAddressDetailsProps } from "@ctypes";
import { ADDRESS_DETAILS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useAddressDetails = ({ placeId }: UseAddressDetailsProps) => {
  const { data: queryData, ...rest } = useQuery<AddressDetailsQuery, AddressDetailsQueryVariables>(
    ADDRESS_DETAILS,
    {
      variables: {
        placeId: placeId!,
      },
      skip: !placeId,
    },
  );

  const data = queryData?.addressDetails;

  return { data, ...rest };
};
